export class UserTokenModel
{
    accessToken: string;
    expiresIn: number;
}